import { useState } from 'react';
import Header from '../../components/Header/Header';
import { formatToNaira, OverideButtonStyle, OverideInputStyle, OverideSelectStyle } from '../../helpers/utils';
import './SiteConfiguration.scss';
import { Alert, Button, Input, Loader, Select } from '@piggytechng/component-library';
import ModalExecuteAction from '../../components/Modals/ModalExecuteAction';
import useSiteconfig from '../../hooks/useSiteconfig';
import { useParams } from 'react-router-dom';

const SiteConfiguration = () => {
  const [updateModal, setUpdateModal] = useState(false);
  const {
    siteConfigMaxMinAmount,
    isLoadingSiteConfigMaxMinAmount,
    siteMaxMinAmount,
    setSiteMaxMinAmount,
    setMaxMinThresholdFn,
    handleAmountChange,
    handleLimitChange,
    isLoading,
    withdrawalLimits,
    isLoadingsWithdrawalLimtsData,
    setWihdrawalLimitFn,
    withdrawalLimitsData,
  } = useSiteconfig();

  const params = useParams();

  const [options] = useState([
    {
      value: 'minimum',
      label: 'Minimum Withdrawal Amount',
    },
    {
      value: 'maximum',
      label: 'Maximum Withdrawal Amount',
    },
  ]);

  return (
    <>
      <Header name="Site Configuration" />

      {isLoadingSiteConfigMaxMinAmount || isLoadingsWithdrawalLimtsData ? (
        <div className="page-loader">
          <Loader color="#0F60D6" />
        </div>
      ) : (
        <>
          {params.type === 'withdrawal-threshold' ? (
            <>
              <div className="site-configuration">
                <div className="site-configuration__body">
                  <div className="site-configuration__body-cards-list">
                    <div className="site-configuration__body-cards-list-item">
                      <span>Minimum Withdrawal Amount</span>
                      {siteConfigMaxMinAmount.minimum === null ? (
                        <h4>{'Not set'}</h4>
                      ) : (
                        <h4>{formatToNaira(siteConfigMaxMinAmount.minimum) || 0}</h4>
                      )}
                    </div>
                    <div className="site-configuration__body-cards-list-item">
                      <span>Maximum Withdrawal Amount</span>

                      {siteConfigMaxMinAmount.maximum === null ? (
                        <h4>{'Not set'}</h4>
                      ) : (
                        <h4>{formatToNaira(siteConfigMaxMinAmount.maximum) || 0}</h4>
                      )}
                    </div>
                  </div>

                  <div className="site-configuration__body-config-container">
                    <Select
                      {...OverideSelectStyle}
                      labelStyle={{ color: '#666766' }}
                      options={options}
                      backgroundColor="#F9FAFB"
                      outlineColor="none"
                      label=" Limit Type"
                      height="60px"
                      placeholder="Select type"
                      value={siteMaxMinAmount.type}
                      onChange={(e) => setSiteMaxMinAmount({ ...siteMaxMinAmount, type: e })}
                    />

                    <Input
                      {...OverideInputStyle}
                      label="Amount"
                      className="user-form-input"
                      height="60px"
                      placeholder="Enter amount"
                      backgroundColor="#F9FAFB"
                      outlineColor="transparent"
                      value={siteMaxMinAmount.amount}
                      type="text"
                      onChange={handleAmountChange}
                    />

                    <Button
                      {...OverideButtonStyle}
                      style={{ width: '250px' }}
                      onClick={() => {
                        if (!siteMaxMinAmount.type || siteMaxMinAmount.amount < 100) {
                          Alert.error('Please select a limit type and enter a valid amount');
                          return;
                        }

                        setUpdateModal(true);
                      }}
                    >
                      Save
                    </Button>
                  </div>
                </div>
              </div>

              <ModalExecuteAction
                modalIsOpen={updateModal}
                setIsOpen={setUpdateModal}
                text={`change the ${siteMaxMinAmount.type === 'minimum_withdrawal_amount' ? 'minimum' : 'maximum'} withdrawal amount?`}
                action={(password: string) => setMaxMinThresholdFn(password)}
                actionColor={'#1734CA'}
                isLoading={isLoading}
              />
            </>
          ) : (
            <>
              <div className="site-configuration">
                <div className="site-configuration__body">
                  <div className="site-configuration__body-cards-list">
                    <div className="site-configuration__body-cards-list-item">
                      <span>Pocket Withdrawal Limit</span>
                      {!withdrawalLimitsData.pocket ? (
                        <h4>{'Not set'}</h4>
                      ) : (
                        <h4>{formatToNaira(withdrawalLimitsData.pocket) || 0}</h4>
                      )}
                    </div>
                    <div className="site-configuration__body-cards-list-item">
                      <span>Bank Withdrawal Limit</span>

                      {!withdrawalLimitsData.bank ? (
                        <h4>{'Not set'}</h4>
                      ) : (
                        <h4>{formatToNaira(withdrawalLimitsData.bank) || 0}</h4>
                      )}
                    </div>
                  </div>

                  <div className="site-configuration__body-config-container">
                    <Input
                      {...OverideInputStyle}
                      label="Bank"
                      className="user-form-input"
                      height="60px"
                      placeholder="Enter bank withdrawal limit"
                      backgroundColor="#F9FAFB"
                      outlineColor="transparent"
                      value={withdrawalLimits?.bank ?? ''}
                      type="number"
                      onChange={(e) => handleLimitChange(e, 'bank')}
                    />

                    <Input
                      {...OverideInputStyle}
                      label="Pocket"
                      className="user-form-input"
                      height="60px"
                      placeholder="Enter Pocket withdrawal limit"
                      backgroundColor="#F9FAFB"
                      outlineColor="transparent"
                      value={withdrawalLimits?.pocket ?? ''}
                      type="number"
                      onChange={(e) => handleLimitChange(e, 'pocket')}
                    />

                    <Button
                      {...OverideButtonStyle}
                      style={{ width: '250px' }}
                      onClick={() => {
                        if (!withdrawalLimits?.pocket && !withdrawalLimits?.bank) {
                          Alert.error('Please enter a valid amount for withdrawal limit');
                          return;
                        }

                        setUpdateModal(true);
                      }}
                    >
                      Save
                    </Button>
                  </div>
                </div>
              </div>

              <ModalExecuteAction
                modalIsOpen={updateModal}
                setIsOpen={setUpdateModal}
                text={`update the withdrawal limit?`}
                action={(password: string) => setWihdrawalLimitFn(password)}
                actionColor={'#1734CA'}
                isLoading={isLoading}
              />
            </>
          )}
        </>
      )}
    </>
  );
};

export default SiteConfiguration;
